import { Box, Button } from "@mui/material";
import { ReactElement } from "react";

import { FlexBox } from "~frontend/components/FlexBox";
import { FormikSubmitButton } from "~frontend/components/forms";

export function CreateOrEditGifFormActions({
  nextDisabled,
  onClickBack,
  onClickNext,
  onClickSubmit,
  onClickCancel,
}: {
  nextDisabled?: boolean;
  onClickBack?: () => void;
  onClickNext?: () => void;
  onClickSubmit?: () => void;
  onClickCancel: () => void;
}): ReactElement {
  return (
    <FlexBox
      sx={{ width: "100%", padding: "0 24px 20px 24px" }}
      justifyContent="space-between"
    >
      <Box>
        {onClickBack && (
          <Button variant="contained" color="tertiary" onClick={onClickBack}>
            Back
          </Button>
        )}
      </Box>
      <Box>
        <Button variant="contained" color="tertiary" onClick={onClickCancel}>
          Cancel
        </Button>
        {onClickNext && (
          <Button
            variant="contained"
            color="primary"
            onClick={onClickNext}
            sx={{ marginLeft: "10px" }}
            disabled={nextDisabled}
          >
            Next
          </Button>
        )}
        {onClickSubmit && (
          <FormikSubmitButton
            variant="contained"
            color="primary"
            onClick={onClickSubmit}
            sx={{ marginLeft: "10px" }}
          >
            Save
          </FormikSubmitButton>
        )}
      </Box>
    </FlexBox>
  );
}
